import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 0;
    flex: 1;
    padding: 10px 12px;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    background-color: ${(props: any) => props.theme.colors.interfacePure0};
    box-sizing: border-box;
    border: 1px solid ${({ theme }) => theme.colors.interfaceGray200 || '#E5E7EB'};
    transition: box-shadow 0.2s ease;

    &:hover {
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    &.clicavel {
        cursor: pointer;
    }

    @media (max-width: 990px) {
        padding: 10px 12px;
        border-radius: 8px;
    }

    .mobile-icon {
        display: none;
        
        @media (max-width: 990px) {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            min-width: 32px;
            border-radius: 50%;
            border: 2px solid ${(props: any) => props.theme.colors.ce5e7eb};
            background-color: ${(props: any) => props.theme.colors.interfacePure0};
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
            margin-bottom: 10px;
            flex-shrink: 0;
            
            svg {
                width: 16px;
                height: 16px;
            }
        }
    }

    .expanded-content-wrapper {
        overflow: hidden;
        transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease;
        /* ERRO27: Reset cursor para área expandida que não é clicável */
        cursor: default;
        
        &.collapsed {
            height: 0 !important;
            opacity: 0;
        }
        
        &.expanded {
            opacity: 1;
        }
        
        .expanded-content-inner {
            padding-top: 12px;
            /* ERRO27: Garantir que o conteúdo expandido tenha cursor padrão */
            cursor: default;
        }
    }

    .top {
        display: flex;
        flex-direction: row;
        gap: 12px;
        width: 100%;
        min-width: 0;
        align-items: center;
        justify-content: space-between;

        @media (max-width: 550px) {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
        }
    }

    .acao {
        display: flex;
        flex: 1;
        min-width: 0;
        color: ${({ theme }) => theme.colors.interfaceText600};
        font-size: 14px;
        font-weight: 500;
        word-break: break-word;
        line-height: 1.4;

        @media (max-width: 990px) {
            font-size: 14px;
        }
    }

    .infos {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 6px;
        flex-shrink: 0;

        @media (max-width: 990px) {
            gap: 6px;
        }

        .icone-top {
            height: 14px;
            width: 14px;
            color: ${({ theme }) => theme.colors.interfaceText400};
            flex-shrink: 0;

            @media (max-width: 990px) {
                height: 14px;
                width: 14px;
            }
        }
        
        svg {
            color: ${({ theme }) => theme.colors.interfaceText400};
        }

            .chevron-container {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 28px;
            height: 28px;
            border-radius: 6px;
            cursor: pointer;
            transition: background-color 0.2s ease;
            margin: -6px;
            padding: 0;
            flex-shrink: 0;
            background: transparent;
            border: none;

            @media (max-width: 990px) {
                width: 28px;
                height: 28px;
                margin: -6px;
            }

            &:hover {
                background-color: ${(props: any) => props.theme.colors.cf3f4f6};
            }

            &:active {
                background-color: ${(props: any) => props.theme.colors.ce5e7eb};
            }

            .chevron {
                transition: transform 0.3s ease;
                height: 16px;
                width: 16px;
                color: ${(props: any) => props.theme.colors.c6b7280};

                @media (max-width: 990px) {
                    height: 16px;
                    width: 16px;
                }
                
                &.expanded {
                    transform: rotate(180deg);
                }
            }
        }
    }
    
    .codigo {
        font-size: 12px;
        font-weight: 500;
        color: ${({ theme }) => theme.colors.interfaceText400};
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        white-space: nowrap;
        flex-shrink: 0;

        @media (max-width: 990px) {
            display: block; /* Show the ID on mobile devices */
            font-size: 11px;
        }
    }

    .bottom {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 8px;
        padding-top: 8px;
        border-top: 1px solid ${({ theme }) => theme.colors.interfaceGray150 || '#F3F4F6'};
        color: ${({ theme }) => theme.colors.interfaceText600};
        font-weight: 500;
        font-size: 12px;
        gap: 6px;
        flex-wrap: wrap;

        @media (max-width: 990px) {
            font-size: 12px;
            margin-top: 8px;
            padding-top: 8px;
            gap: 6px;
        }

        > svg {
            height: 14px;
            width: 14px;
            color: ${({ theme }) => theme.colors.interfaceText400};
            flex-shrink: 0;

            @media (max-width: 990px) {
                height: 14px;
                width: 14px;
            }
        }

        .tipo_responsavel {
            padding: 2px 6px;
            border-radius: 10px;
            font-weight: 600;
            font-size: 10px;
            background-color: ${(props: any) => props.theme.colors.cf3f4f6};
            color: ${(props: any) => props.theme.colors.c374151};
            white-space: nowrap;
            flex-shrink: 0;
            border: 1px solid ${(props: any) => props.theme.colors.ce5e7eb};

            @media (max-width: 990px) {
                padding: 2px 6px;
                font-size: 10px;
            }
        }
    }
`;
